var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google__G__Logo 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.575 20.4503C39.575 19.1337 39.4583 17.8837 39.2583 16.667H20.425V24.1837H31.2083C30.725 26.6503 29.3083 28.7337 27.2083 30.1503V35.1503H33.6417C37.4083 31.667 39.575 26.5337 39.575 20.4503Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.425 39.9997C25.825 39.9997 30.3417 38.1997 33.6417 35.1497L27.2083 30.1497C25.4083 31.3497 23.125 32.0831 20.425 32.0831C15.2083 32.0831 10.7917 28.5664 9.20835 23.8164H2.57501V28.9664C5.85835 35.4997 12.6083 39.9997 20.425 39.9997Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.20832 23.8165C8.79165 22.6165 8.57499 21.3332 8.57499 19.9999C8.57499 18.6665 8.80832 17.3832 9.20832 16.1832V11.0332H2.57499C1.20832 13.7332 0.424988 16.7665 0.424988 19.9999C0.424988 23.2332 1.20832 26.2665 2.57499 28.9665L9.20832 23.8165Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.425 7.91667C23.375 7.91667 26.0083 8.93334 28.0917 10.9167L33.7917 5.21667C30.3417 1.98334 25.825 0 20.425 0C12.6083 0 5.85835 4.5 2.57501 11.0333L9.20835 16.1833C10.7917 11.4333 15.2083 7.91667 20.425 7.91667Z",
    fill: "#EA4335"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.798ff9803eede56eb187219db0daba11.svg";
export { ForwardRef as ReactComponent };